<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 7v18a2 2 0 01-2 2h-4.82v-8.52H23l.43-3.32h-3.25V13a1.82 1.82 0 01.34-1.21 1.65 1.65 0 011.31-.4h1.75v-3A20.33 20.33 0 0021 8.32a4.24 4.24 0 00-3.12 1.15 4.32 4.32 0 00-1.17 3.24v2.45h-2.83v3.32h2.86V27H7a2 2 0 01-2-2V7a2 2 0 012-2h18a2 2 0 012 2z"/></svg>